import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Modal, Row, Image } from 'react-bootstrap';
import { RefreshCw, AlertOctagon } from 'lucide-react';
import Chart from "react-apexcharts";
import moment from 'moment/moment';
import Loader from '../Loader/Loader';
import callAPI from '../../../commonservices/APIRequests';
import { convertCurrencyToShortNotation, convertToBaseFormatDate, currencifyInDollars, MaskAccountNumber } from '../../../commonservices/CommonMethods';
import { X } from 'lucide-react';
import PopupIcons_ViewDailyBalance from '../../../assets/images/Popup-Icons/PopupIcons_View_Daily_Balance_White.svg'
import RefreshIcon from '../../../assets/images/TableFilters/TableFilterRefreshIcon.svg';
import SelectBox from '../../Shared/common/components/Shared_FormControls/SelectBox/SelectBox';
import CustomisedReactDatePicker from '../common/components/Shared_FormControls/CustomisedReactDatePicker/CustomisedReactDatePicker';

const SharedBankDailyBalance = (props) => {
    const dt = new Date();

    const [chartOptions, setChartOptions] = useState({});
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBankID, setSelectedBankID] = useState(props.bankId);
    const [to, setTo] = useState(moment(dt).format('yyyy-MM-DD'));
    const [from, setFrom] = useState(moment(dt).format('yyyy-MM-DD'));
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState()
    const [isLoaded, setLoaded] = useState(true);
    const [refreshCw, setRefreshCw] = useState(false)
    const [series, setChartDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState({});
    const [assetReportUpdatedDate, setAssetReportUpdatedDate] = useState("")

    useEffect(() => {
        getBankOptions(props.dealerId)
        showDailyBalance(false);
    }, [])
    //getBank list
    const getBankOptions = (dealer_id) => {
        setLoaded(false)
        return callAPI.get('/payment/api/v1/plaid/getDealerBanks', { dealerId: dealer_id })
            .then((response) => {
                if (response.status === 200) {
                    setBankOptions(response.data.accounts ? response.data.accounts.map((el) => ({
                        value: el._id,
                        label: `${el.account?.bankName} (${el.account?.accountNumber.substr(-4)})`
                    })) : [])
                    setLoaded(true)
                } else {
                    setBankOptions([])
                    console.error(response.message)
                    setLoaded(true)
                }
            })
    }

    //get Daily Balance
    const showDailyBalance = (isAsset = false) => {


        let req = {}
        if (isAsset) {
            req = {
                dealerId: props.dealerId,
                bankId: selectedBankID ? selectedBankID : props.bankId,
                isAsset: isAsset
            }
        } else {
            req = {
                dealerId: props.dealerId,
                bankId: selectedBankID ? selectedBankID : props.bankId,
                isAsset: isAsset,
                startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
                endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
            }
        }


        setLoaded(false)

        return callAPI.get('/payment/api/v1/plaid/getDailyBalance', req)
            .then((response) => {
                if (response.status === 200) {
                    setLoaded(true)
                    // setstatusLoaded(true)
                    // setConfirmationPopupState({ ...confirmationPopupState, showPopup: true })


                    if (response?.data?.startDate) {
                        setStartDate(moment(new Date(response?.data?.startDate)).format('yyyy-MM-DD'))
                    }
                    if (response?.data?.endDate) {
                        setEndDate(moment(new Date(response?.data?.endDate)).format('yyyy-MM-DD'))
                    }
                    if (response?.data?.assetReportUpdatedDate) {
                        setAssetReportUpdatedDate(response?.data?.assetReportUpdatedDate)
                    }

                    setChartOptions({
                        chart: {
                            height: 350,
                            type: 'line',
                            zoom: {
                                enabled: false
                            }
                        },
                        dataLabels: {
                            enabled: false
                        },
                        stroke: {
                            curve: 'straight',
                            colors: ['#243B7F']
                        },
                        colors: ['#243B7F'],
                        grid: {
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5
                            },
                        },
                        xaxis: {
                            categories: response.data && response.data.dailyBalance && response.data.dailyBalance.length > 0 ? response.data.dailyBalance.map(responseData => moment.utc(responseData.date).format('MMM DD')) : [],
                        },
                        yaxis: {
                            labels: {
                                formatter: function (value) {
                                    return '$' + convertCurrencyToShortNotation(value)
                                }
                            },

                        },

                    })
                    setChartDetails([{
                        name: "Balance",
                        data: response.data && response.data.dailyBalance && response.data.dailyBalance.length > 0 ? response.data.dailyBalance.map(responseData => responseData.balance) : []
                    }])

                    setBankDetails(response.data?.bankDetails)

                    // getBankOptions(props.dealerId)
                    // setSelectedBankDetails(response.data && response.data.bankDetails ? response.data.bankDetails : {})


                }
                else {
                    setRefreshCw(false)
                    setLoaded(true)
                    // setstatusLoaded(true)
                    // setToaster({
                    //     header: 'Error',
                    //     class: 'error-toaster',
                    //     content: response.message,
                    //     showToaster: true
                    // });
                    // setConfirmationPopupState({
                    //     data: "",
                    //     showPopup: false
                    // })
                }

            });
    };

    return (
        <Modal className={`default-medium-popup default-popup modal-backdrop-bg-color`} show={props.showModalBDB}
            onHide={props.cancelBDB} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                <Modal.Title>
                    {/* {props.icon ? props.icon : <span className='popup-title-icon'><MapPin /></span>} */}
                    <span className='popup-title-icon'><img src={PopupIcons_ViewDailyBalance} alt="logo" /></span>
                    <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : 'Bank Daily Balance'}</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Loader show={!isLoaded} styleType='absolute' />
                    <p className='dealer-name-popup mb-2'>{props.dealerName ? props.dealerName : (props.dealerDetails && props.dealerDetails.dealerName) ? props.dealerDetails.dealerName : ''} ({props.dealerReference ? props.dealerReference : (props.dealerDetails && props.dealerDetails.dealerReference) ? props.dealerDetails.dealerReference : ''})</p>
                    <Row className="mb-30 pl-0 pr-3 pb-0 align-items-start">
                        <Col>
                            {/* <h2 className="widget-title mb-3 mt-1">Bank Daily Balance </h2> */}
                            <Form.Row className="datePickerStyles">
                                {
                                    props?.showBankSelection ? <Form.Group className="mb-0" as={Col} md={4} controlId="formACHFrom">
                                        {/* <Form.Label className="label-color single-line-label mb-0">
                                        Select Bank
                                    </Form.Label> */}
                                        <SelectBox
                                            zeroMargin
                                            label='Select Bank'
                                            name="Daily Balance"
                                            objectKey='dailyBalance'
                                            value={selectedBankID}
                                            onChange={(key, value) => setSelectedBankID(value)}
                                            options={bankOptions}
                                        />
                                    </Form.Group> : null
                                }

                                <Form.Group as={Col} md={3} className="mb-0 datePickerIconStyles clear-Date-For-Datepicker">
                                    {/* <Form.Label className="label-color single-line-label mb-0">To</Form.Label> */}
                                    <CustomisedReactDatePicker
                                        zeroMargin
                                        label='From'
                                        dateFormat="MM-dd-y"
                                        autoPlacement="bottom"
                                        value={startDate ? new Date(moment(startDate).format('MM-DD-YYYY')) : null}
                                        onChange={(type, date) => setStartDate(date)}
                                        objectKey='startDate'
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={3} className="mb-0 datePickerIconStyles clear-Date-For-Datepicker">
                                    {/* <Form.Label className="label-color single-line-label mb-0">From</Form.Label> */}
                                    <CustomisedReactDatePicker
                                        zeroMargin
                                        label='To'
                                        objectKey='endDate'
                                        dateFormat="MM-dd-y"
                                        autoPlacement="bottom"
                                        value={endDate ? new Date(moment(endDate).format('MM-DD-YYYY')) : null}
                                        onChange={(type, date) => setEndDate(date)}
                                    />
                                </Form.Group>
                                <div className='col-'>
                                    <Button type="button" variant="primary" md={2}
                                        className="md-btn mb-0 mt-2 default-btn"
                                        onClick={() => {
                                            showDailyBalance();
                                            setLoaded(false);
                                            setRefreshCw(false);
                                        }}
                                    >Get</Button>
                                </div>
                            </Form.Row>
                        </Col>
                    </Row>
                    {
                        bankDetails ?
                            <Row className="mb-1 mx-0">
                                <div className="p-0 mr-4">
                                        <p className="content-text-14px">
                                            <span className="bold-700">Bank Name:  </span>
                                            {bankDetails.bankName ? bankDetails.bankName : ''}
                                            <span className='ml-1'>({bankDetails.accountNumber ? MaskAccountNumber(true, bankDetails.accountNumber) : ''})</span>
                                        </p>
                                    </div>
                                <div className="p-0 mr-4">
                                        <p className="content-text-14px">
                                            <span className="bold-700">Mask:  </span>
                                            {bankDetails.mask}

                                        </p>
                                    </div>
                                <div className="p-0 mr-4">
                                        <p className="content-text-14px"><span className="bold-700">Balance Amount:  </span> {currencifyInDollars(bankDetails.bankBalance)}</p>
                                    </div>
                                    {bankDetails.plaidConnectionFailedDate &&
                                    <div className="p-0 mr-4">
                                            <p className="content-text-14px">
                                                <span className="bold-700">Plaid Connection Failed on: </span>
                                                {convertToBaseFormatDate(bankDetails.plaidConnectionFailedDate)}
                                            </p>
                                        </div>
                                    }
                            </Row>
                            : null
                    }
                    <div>
                        <div className="d-flex flex-column-reverse mb-2">
                            {!refreshCw ? <p className='d-flex align-items-center mt-1'>
                                <AlertOctagon size={18} className="mr-1 content-text-color" />
                                {bankDetails?.plaidConnectionFailedDate ?
                                    <span>Please <span className="text-decoration-underline bold-500">click here</span> to get real-time balance.</span>
                                    :
                                    <span>Please <span className="cursor-pointer text-decoration-underline bold-700"
                                        onClick={() => {
                                            showDailyBalance(true);
                                            setRefreshCw(true)
                                        }}
                                    >
                                        click here</span> to get real-time balance.</span>}
                            </p> :
                                <p>We are fetching real time balance from plaid - In Progress
                                    {/* <RefreshCw style={{ marginLeft: '15px' }} size={18} width={30} height={30} */}
                                    <span className='ml-2'>
                                        <Image src={RefreshIcon} width={12}
                                            className="rotate-refresh align-self-center" />
                                    </span>
                                </p>
                            }
                            <div>
                                {assetReportUpdatedDate ? <p>Updated on: {convertToBaseFormatDate(assetReportUpdatedDate, true, true)} </p> : null}
                            </div>
                        </div>

                        <Chart options={chartOptions} series={series} type="line" height={350} />
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="primary" className="default-btn" onClick={(event) => props.primaryAction(event)}>{props.primaryActionLabel ? props.primaryActionLabel : "Yes"}</Button>
                <Button variant="outline-secondary" className="default-btn" onClick={(event) => props.secondaryAction(event)}>{props.secondaryActionLabel ? props.secondaryActionLabel : "No"}</Button>
            </Modal.Footer> */}
        </Modal>
    )
}

export default SharedBankDailyBalance
